module.exports = __webpack_public_path__ + "img/community2@2x.dec0c9fb.png";